<ion-modal>
    <ng-template>
        <div class="overflow-y-auto">
            <div class="flex-align-center inset-0 flex">
                <div class="flex-column flex h-full w-full bg-white">
                    <div class="p-4 py-5">
                        <div class="grid grid-cols-[1rem_1fr_1rem] gap-2 pb-5 pt-1">
                            <button (click)="closeModal()">
                                <ion-icon
                                    class="text-2xl text-primary dark:text-contrast-yellow"
                                    name="arrow-back-outline"></ion-icon>
                            </button>
                            <h2 class="text-center text-base font-bold leading-7">
                                {{ 'SET_TOP_UP_AMOUNT' | translate }}
                            </h2>
                        </div>

                        <div>
                            <ion-input
                                class="rounded-lg border border-solid border-[#F2F2F2] bg-grey-white_smoke dark:border-contrast-yellow dark:bg-contrast-black dark:text-contrast-yellow"
                                [(ngModel)]="amount"
                                [attr.min]="minAmount"
                                [attr.max]="maxAmount"
                                (ionInput)="validateInput($event)"
                                fill="outline"
                                inputmode="decimal"
                                type="text"></ion-input>
                            <p class="mt-1 text-xs font-bold text-ironside_grey dark:text-contrast-yellow">
                                {{ 'MAX_TOP_UP_AMOUNT_LIMIT' | translate }}
                            </p>
                            <ridango-error class="text-xs font-bold text-red-500" *ngIf="showError">
                                {{ 'AMOUNT_OUT_OF_RANGE' | translate }}
                            </ridango-error>
                        </div>

                        <div class="mt-3">
                            <button
                                class="text-bold w-full rounded-lg bg-secondary py-5 font-bold leading-5 text-white dark:bg-contrast-yellow dark:text-contrast-black"
                                [attr.aria-label]="'SET_AMOUNT' | translate"
                                (click)="setAmount()"
                                (keydown.enter)="setAmount()"
                                (keydown.space)="setAmount()">
                                {{ 'SET_AMOUNT' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</ion-modal>
